import { signalingChatMessageSent } from 'features/chat/actions';
import { crashRecorderProbeSaga } from 'features/dev-mode/sagas/crashRecorderProbeSaga';
import { takeEvery } from 'redux-saga/effects';
import { canExposeInternals } from 'utils/development';

export default function* devModeWatcher() {
  if (canExposeInternals()) {
    yield takeEvery(signalingChatMessageSent, crashRecorderProbeSaga);
  }
}
